const CARESPOC = [
  {
    value: 'Merchant',
    label: 'Merchant'
  },
  {
    value: 'Partner',
    label: 'Partner'
  }
];

const BASERATETYPE = [
  {
    value: 'PERCENTAGE',
    label: 'PERCENTAGE'
  },
  {
    value: 'FLAT',
    label: 'FLAT'
  }
];

export { CARESPOC, BASERATETYPE };
